import { submissionEnvironmentActionTypes } from '@actions/actionTypes/submissionEnvironment';
import { AttachmentEntityInterface, UserEntityInterface } from '@types';
import { getAllUsers } from '@services/userService';
import { LangEnum } from '@enums';
import _cloneDeep from 'lodash/cloneDeep';

export const setSubmissionUser = (user: UserEntityInterface) => {
  return {
    type: submissionEnvironmentActionTypes.SET_SUBMISSION_USER,
    payload: user,
  };
};

export const setSubmissionAttachmentsExecuted = (
  attachmentsExecuted: AttachmentEntityInterface[]
) => {
  return {
    type: submissionEnvironmentActionTypes.SET_SUBMISSION_ATTACHMENTS_EXECUTED,
    payload: attachmentsExecuted,
  };
};

export const setSubmissionAttachments = (attachments: AttachmentEntityInterface[]) => {
  return {
    type: submissionEnvironmentActionTypes.SET_SUBMISSION_ATTACHMENTS,
    payload: attachments,
  };
};

export const setSubmissionContext = (context: string | object) => {
  return {
    type: submissionEnvironmentActionTypes.SET_SUBMISSION_CONTEXT,
    payload: typeof context === 'object' ? _cloneDeep(context) : JSON.parse(context || '{}'),
  };
};

export const setScale = (scale: number) => {
  return {
    type: submissionEnvironmentActionTypes.SET_SCALE,
    payload: scale,
  };
};

export const setRendererWidth = (rendererWidth: number) => {
  return {
    type: submissionEnvironmentActionTypes.SET_RENDERER_WIDTH,
    payload: rendererWidth,
  };
};

export const setIsSubmissionDownload = (isDownload: boolean) => {
  return {
    type: submissionEnvironmentActionTypes.SET_SUBMISSION_DOWNLOAD,
    payload: isDownload,
  };
};

export const setEmployeeNumber = (value: number) => {
  return {
    type: submissionEnvironmentActionTypes.SET_EMPLOYEE_NUMBER,
    payload: value,
  };
};

export const makeEmployeeNumber = () => {
  return async (dispatch) => {
    const { total } = await getAllUsers({ limit: 1 });
    dispatch(setEmployeeNumber(Math.ceil(total / 100) * 100));
  };
};

export const setSubmissionEnvironmentLanguage = (language: LangEnum) => {
  return {
    type: submissionEnvironmentActionTypes.SET_SUBMISSION_LANGUAGE,
    payload: language,
  };
};
